import { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import config from "src/config/config";
import { theme } from 'styled-tools';
import { Link } from 'react-router-dom';

function TwentyFreeSpinsPromo(props) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <InformationWrapper>
                <TitleText>
                    {brandId=== 39 || brandId=== 40 ? 
                     <h3>New players get 20 Free Spins on Fortune <br />Gems 2 after signup</h3> : 
                     brandId === 61 ? <h3>Register today & receive 20 Free Spins on <br /> Fortune Gems 2</h3> : 
                     brandId === 33 ? <h3>Register today & receive 20 Free <br />Spins on Super Ace</h3> :
                     <h3>Sign up & get 20 Free Spins on Money <br /> Coming (JILI) instantly!</h3>}
                </TitleText>
                <Container className="">
                      <ImageWrap>
                         <img
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.freeSpinsYoloGameThumb}`}
                            alt="How to Join"
                        />
                        <Link to={brandId === 33 ? "/slots/jili-slot/superace" : brandId===39 || brandId===40 || brandId===61 ? "/slots/jili-slot/fortunegems2" : "/slots/jili-slot/moneycoming"}>
                            <img
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.freeSpinsYoloPlayNowBtn}`}
                                alt="How to Join"
                                className='gameBtn'
                            />
                        </Link>
                      </ImageWrap>
                </Container> 

                <MonthlyPrizeWrap>
                    <MainTitle>How to Participate</MainTitle>
                    <MonthlyPrizeSec>
                        <img src={`${config.imageV3Host}/static/cashsite/${theme.image.freeSpinsYoloSteps}`}/>
                    </MonthlyPrizeSec>
                </MonthlyPrizeWrap>
                
                <TermsConditionsSec>
                  <MainTitle>Terms & Conditions</MainTitle>
                    <ol>
                        <li>Offer valid for newly registered players only.</li>
                        <li>{brandId===61 ? "Each Free Spin is worth $0.1 USD" : "Each Free Spin is worth ₹1." }</li>
                        <li>Winnings from Free Spins carry a 5x wagering <br /> requirement before withdrawal.</li>
                        <li>Free Spin winnings are forfeited if the first deposit is <br /> made after playing the spins.</li>
                        <li>Standard brand T&amp;Cs apply.</li>
                    </ol>
                </TermsConditionsSec>
            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(TwentyFreeSpinsPromo));

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 3rem 0 0rem 0;
    margin: 0em 1.2em 1.2em 1.2em;
    border: 1px solid #fff;  
    display: flex;
    flex-direction: column;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.freeSpinsYoloInnerBg")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;

    p {
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        text-transform: capitalize;
        margin: 0;
    }
    
    strong {
        font-weight: 800;
    }

    .textPadBtm {
        padding-bottom: 2rem;
    }

    h2 {
        color: #FFEE00;
        text-align: center;
        font-size: 30px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
    }

    h3 {
        color: #FFF;
        text-align: center;
        text-shadow: 0 2.771px 2.771px rgba(0, 0, 0, 0.55);
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 29.578px; /* 151.25% */
        text-transform: capitalize;
    }
`;

const TitleText = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    /* padding: ${theme('palette.liveJackpotTittleTextPadding')}; */
    position: relative;
    gap: 22px;
    /* margin-bottom: 2rem; */

    .dateImg {
        width: 180px;
    }

    .headTextImg {
        width: 481px;
    }
`;

const Container = styled.div`
    width: 100%;
    max-width: 1366px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin: 0 auto;

    &.morePadding {
        padding-top: 3rem;
        padding-bottom: 2rem;
    }
`;

const MainTitle = styled.h4`
    color: ${theme('palette.freeSpinsPromoHead')};
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 35px; /* 175% */
    text-transform: capitalize;
    margin: 3px 0px 15px 0px;
`;

const MonthlyPrizeSec = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;

    & img {
        width: 60%;
        height: auto;
    }
`;

const MonthlyPrizeWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: center;
    margin-top: 3em;
`;

const TermsConditionsSec = styled.div`
     display: flex;
     flex-direction: column;
     align-items: center;
     gap: 5px;
    padding: 4em 0;

     & ol {
        width: 37%;
        margin-top: 5px;

        & li {
            color: #FFF;
            text-align: justify;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 30px;
            text-transform: capitalize;
            margin: 3px 0px;
            margin-bottom: 7px;
        }
     }
`;

const ImageWrap = styled.div`
       width: 15%;
       display: flex;
       justify-content: center;
       flex-direction: column;
       align-items: center;
    

        & img {
            width: 100%;
            height: auto;
        }     

        & .gameBtn {
            width: 80%;
            margin-top: 1em;
            cursor: pointer;
        }
        & a {
            text-align: center;
        }
`